import gql from 'graphql-tag'
const SPEAKER_QUERY = gql`
	query ($conferenceSeriesId: String!, $pagesize: Int!, $page: Int!) {
		vueExperts(
			conferenceIds_in: [$conferenceSeriesId]
		  PAGE_SIZE: $pagesize
		  PAGE: $page
		  SORT: {surname: 1}
		) {
		  Experts {
			_id
			surname
			forename
			bio
			slug
			__typename
			company
			avatarSquareSmall {
			  x
			  xx
			  xxx
			  __typename
			}
			qualifications {
			  _id
			  name
			  __typename
			}
		  }
		  __typename
		}
	  }
	`


const EXPERT_BY_SLUG_QUERY  = gql`
query($slug: String!,$conferenceBrandId:String!){
	vueExpert(slug:$slug,conferenceBrandId:$conferenceBrandId){
    Expert{
		_id
		forename
		surname
		company
		bio
		bioEn
		bioDe
		facebook
		twitter
		linkedIn
		blog
    	slug
		avatarSquareSmall {
		x
		xx
		xxx
		svg
		}
		sessions{
			name
			_id
			primaryTrack{
				name
			   slug
		   }
			slugNames
			localizedStartDate
			localizedEndDate
			updatedAt
			type
			eventId
			conferenceIds
		}
    }
  }
}
`

const SESSION_BY_SLUG_QUERY = gql`
query ($sessionSlug: [String]!,$brandId:String!) {
	vueSessions(
		slugs_in: $sessionSlug
		conferenceBrandId:$brandId
		) {
		Sessions {
			_id
			name
			slugNames
			sessionType{
				name
				slug
			}
			longAbstract
			localizedStartDate
			conferenceIds
			localizedEndDate
			primaryTrack{
				name
			   slug
		   }
			details
			roomName
			workshopShortLabel
			workshopRequirements
			experts {
				surname
				company
				forename
				slug
				avatarSquareSmall {
					x
					xx
					xxx
					xxxx
					svg
				}
			}
			tracks {
				_id
				name
				slug
			}
		}

		__typename
	}
	__typename
}
`

const SESSIONS_QUERY = (variablesForQier) => {
	return gql`
query ($id: String!, $page_size: Int!, $page: Int!,,${variablesForQier.trackIn != "" ? `$trackIn: [String]!` : "" }) {
	vueSessions(
		conferenceIds_in: [$id]
		SORTS: [{startDate: 1}, {name: 1}]
		${variablesForQier.trackIn != "" ? `trackIds_in: $trackIn` : "" },
	  PAGE: $page
	  PAGE_SIZE: $page_size
	) {
	  Sessions {
		_id
		name
		accessible
		eventId
		localizedStartDate
		localizedEndDate
		timezone
		details
		type
		sessionType {
		  _id
		  type
		  uniqueId
		  type
		  name
		  slug
		  colourHexCode
		  image {
			xx
			xxx
			xxxx
			__typename
		  }
		  __typename
		}
		timezone
		localizedStartDate
		qualifications {
		  _id
		  name
		  nameDe
		  uniqueId
		  __typename
		}
		qualificationIds
		localizedEndDate
		longAbstract
		workshopShortLabel
		roomName
		language
		slugNames
		primaryTrackId
		primaryTrack {
		  name
		  _id
		  slug
		  __typename
		}
		trackIds
		tracks {
		  name
		  _id
		  uniqueId
		  __typename
		  slug
		}
		workshopRequirements
		experts {
		  surname
		  _id
		  forename
		  __typename
		  company
		  bio
		  slug
		  avatarSquareSmall {
			x
			xx
			xxx
			xxxx
			__typename
		  }
		}
		pdf {
		  name
		  type
		  url
		  uploadedAt
		  __typename
		}
		__typename
	  }
	  __typename
	}
  }
	`
}

const SESSIONS_TRACKS_QUERY = gql`
query ($id: String!) {
	vueSessions(
		conferenceIds_in: [$id]
	) {
	  Sessions {
		_id
		name
		trackIds
		tracks {
		  name
		  _id
		  uniqueId
		  __typename
		  slug
		}
		__typename
	  }
	  __typename
	}
  }
	`


const SESSION_BY_TRACK_QUERY = gql`
query (
	$id: [String]!
	$conferenceId: [String]!
) {
	vueSessions(
		trackIds_in: $id
		conferenceIds_in: $conferenceId
		PAGE: 1
		PAGE_SIZE: 3
	) {
		Sessions {
			_id
			name
			slugNames
			primaryTrack {
				name
				_id
				slug
				__typename
			}
			trackIds
			tracks {
				name
				_id
				uniqueId
				__typename
				slug
			}

			__typename
		}
		__typename
	}
}`

const TRACK_EXPERT_QUERY = gql`
query ($conferenceSeriesId: String!, $pagesize: Int!, $page: Int!, $trackFilter: [String]!) {
	vueExperts(
		conferenceIds_in: [$conferenceSeriesId]
		PAGE_SIZE: $pagesize
		PAGE: $page
		trackIds_in: $trackFilter
		SORT: {surname: 1}
	) {
	  Experts {
		_id
		surname
		forename
		bio
		slug
		__typename
		company
		avatarSquareSmall {
		  x
		  xx
		  xxx
		  __typename
		}
		qualifications {
		  _id
		  name
		  __typename
		}
	  }
	  __typename
	}
}
`
const TRACK_BY_SLUG = gql`
query ($conferenceBrandId: String!,$slug: String!) {
	tracks(conferenceBrandId: $conferenceBrandId,slug:$slug) {
		Tracks {
			name
			slug
			uniqueId
			_id
		}
	}
}
`
const CAT_SPECIFIC_COURSES = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(
		type: BLOCKBUSTER_COURSE
		input: { PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring }
	) {
		blockbusterCourses {
			Meta {
				count
				__typename
			}
			Courses {
				_id
				name
				accessible
				slug
				teaserImage{
					x xx xxx svg
				}
				colourHexCode
				localizedStartDate
				localizedEndDate
				level
				duration
				
				slogan
				__typename
			}
			__typename
		}
		__typename
	}
	__typename
}
`;

const CAT_SPECIFIC_CONFERENCES = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(withAskFrank: false, type: COURSE, input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring}) {
	  courses {
		Meta {
		  count
		  __typename
		}
		Courses {
		  _id
		  name
		  accessible
		  slug
		  localizedStartDate
		  localizedEndDate
		  slogan
		  timezone
		  genre
		  experts {
			name forename company
			__typename
		  }
		  teaserImage {
			x xx xxx 
		  }
		  transparentLogo {
			x xx xxx svg
			__typename
		  }
		  colourHexCode
		  __typename
		}
		__typename
	  }
	  __typename
	}
  }
  
`;

const CAT_SPECIFIC_EXPERTS = 
`
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(type: AUTHOR, input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring}) {
	  authors {
		Meta {
		  count
		  __typename
		}
		Authors {
		  _id
		  __typename
		  slug
		  isLegacy
		  forename
		  surname
		  title
		  salutation
		  name
		  bio
		  email
		  avatarSquareLarge {
			x
			xx
			xxx
			__typename
		  }
		  avatarSquareSmall {
			x
			xx
			xxx
			__typename
		  }
		  articles {
			_id
			__typename
			slug
			type
			name
			subtitle
			read
		  }
		}
		__typename
	  }
	  __typename
	}
  }
        `
;

const CAT_SPECIFIC_INTERVIEWS = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(
		type: INTERVIEW
		input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring}
	) {
    interviews {
      Meta {
        count
        __typename
      }
      Articles {
        _id
        __typename
        slug
        name
        type
        subtitle
        abstract
        publishedAt
        primaryCategory {
          _id
          slug
          slugEn
          __typename
        }
        teaserImage {
          x
          xx
          xxx
          xxxx
          __typename
        }
        intervieweeId
        interviewee {
          name
          _id
          __typename
          slug
          surname
          company
          forename
          avatarSquareLarge {
            x
            xx
            xxx
            __typename
          }
        }
        authors {
          _id
          __typename
          slug
          name
          avatarSquareSmall {
            xx
            __typename
          }
          avatarSquareLarge {
            xx
            __typename
          }
        }
        issue {
          designation
          brand {
            name
            __typename
          }
          __typename
        }
      }
      __typename
    }
    __typename
  }
}
`;


const CAT_SPECIFIC_MAGAZINE = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(
		type: ISSUE
		input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring}
	) {
    issues {
      Meta {
        count
        __typename
      }
      Issues {
        _id
        __typename
        slug
        brandId
        brand {
          __typename
          slug
        }
        designation
        coverStory
        cover {
          x
          xx
          xxx
          xxxx
          __typename
        }
        articles {
          primaryCategory {
            _id
            name
            slug
            slugEn
            __typename
          }
          __typename
          slug
          _id
          name
          subtitle
          brand {
            name
            __typename
          }
          issue {
            designation
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
`;


const CAT_SPECIFIC_SERIES = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(
	type: SERIES
		input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring}
	) {
    series {
      Meta {
        count
        __typename
      }
      ArticleSeriesItems {
        _id
        type
        publicationDate
        name
		slug
        authors {
          name
          __typename
        }
        description
        teaser {
          xxxx
          xx
          xxx
          x
          __typename
        }
        articles {
          _id
          type
          name
		  slug
          subtitle
          read
          issue {
            designation
			slug
            publicationDate
            thumbnailSmall {
              xxx
              __typename
            }
            brand {
              name
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
`;
const CAT_SPECIFIC_ARTICLE = `
query ($page: Int!, $pagesize: Int!, $querystring: String!, $years: [Int]!, $brandIDs: [String]!, $categoryIDs: [String]!) {
  advancedSearch(
		type: ARTICLE
		input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring, filter: {years: $years, brandIds: $brandIDs, categoryIds: $categoryIDs}}
	) {
    articles {
      Meta {
        count
        __typename
      }
      Articles {
        _id
        tags {
          _id
          name
          __typename
        }
        categories {
          _id
          name
          __typename
        }
        accessible
		primaryCategory {
          _id
          slug
          slugEn
          __typename
        }
		archetypeArticle{
			primaryCategory {
				slug
			}
		}
        read
		slug
        name
        subtitle
        publicationOrder
        streamOrder
        teaserImage {
          x
          xx
          xxx
          xxxx
          __typename
        }
        teaserCopyright
        abstract
        type
        articleSeriesId
        articleSeries {
          _id
          name
          description
          teaser {
            x
            xx
            __typename
          }
          __typename
        }
        authors {
          _id
          forename
          surname
          __typename
        }
        issue {
          _id
          designation
          coverStory
          publicationDate
          cover {
            x
            xx
            xxx
            xxxx
            __typename
          }
          brand {
            _id
            name
            __typename
          }
          __typename
        }
        brand {
          _id
          name
          logo {
            x
            xx
            xxx
            xxx
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
`;
const CAT_SPECIFIC_HIGHLIGHT = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(
		type: HIGHLIGHT
		input: { PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring }
	) {
		highlights {
			courses {
				Meta {
					count
					__typename
				}
				Courses {
					_id
					name
					accessible
					slug
					localizedStartDate
					localizedEndDate
					slogan
					marketingUrl
					experts {
						forename
						surname
					}
					curator {
						name
					}
					timezone
					lessons {
						_id
						name
						localizedStartDate
						localizedEndDate
						timezone
						experts {
							_id
							slug
							forename
							surname
							company
							__typename
						}
						__typename
					}
					genre
					teaserImage {
						xx
						xxx
						__typename
					}
					__typename
				}
				__typename
			}
			__typename
		}
		__typename
	}
}
`;
const CAT_SPECIFIC_COLUMN = gql`
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
	advancedSearch(
		type: COLUMN
		input: { PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring }
	) {
		columns {
			Meta {
				count
				__typename
			}
			ArticleSeriesItems {
				_id
				type
				slug
				publicationDate
				name
				authors {
					name
					slug
					__typename
				}
				description
				teaser {
					xxxx
					xx
					xxx
					x
					__typename
				}
				articles {
					_id
					type
					name
					subtitle
					read
					primaryCategory {
						slug
					}
					slug
					issue {
						designation
						publicationDate
						thumbnailSmall {
							xxx
							__typename
						}
						brand {
							name
							__typename
						}
						__typename
					}
					__typename
				}
				__typename
			}
			__typename
		}
		__typename
	}
}
`;

const CAT_SPECIFIC_COLUMN1 = `
query ($page: Int!, $pagesize: Int!, $querystring: String!) {
  advancedSearch(type: COLUMN, input: {PAGE: $page, PAGE_SIZE: $pagesize, keyword: $querystring}) {
    columns {
      Meta {
        count
        __typename
      }
      ArticleSeriesItems {
        _id
        type
        publicationDate
        name
		slug
        authors {
          name
          __typename
        }
        description
        teaser {
          xxxx
          xx
          xxx
          x
          __typename
        }
        articles {
          _id
          type
          name
          subtitle
          read
          issue {
            designation
            publicationDate
            thumbnailSmall {
              xxx
              __typename
            }
            brand {
              name
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
`;
const CAT_SPECIFIC_ADD_EVENT = gql`
query ($keyword:String!, $page:Int!, $pagesize:Int!){
      aggregatedCategory(
          type: ALL
            PAGE_SIZE:$pagesize
            PAGE:$page
            _id:$keyword
        ) {
          adverts {
            __typename
            Meta{
              count
            }
            Adverts{
              _id
              type
              html
              __typename
              priority
              images
              baseUrl
            }
          }
        }
      }
`;

const GET_BRAND_COMPLEXES = gql `
query AllBrandComplexes {
  brandComplexes(
      SORT: {
          order: 1
      }
  ) {
      Meta {
          count
      }
      BrandComplexes {
          _id
          name
          slug
          slogan
          engagement
          primaryColourHexCode
          secondaryColourHexCode
          background {
            svg
              xx
              xxx
              xxxx
          }
          logo {
              svg
          }
          categoryIds
          categories{
            _id
            name
          }
          order
      }
  }
}
`;

const GET_BRAND = gql `
query AllBrandComplexes {
	pieceOfContent(
		type: ACADEMY
		brandComplexId: "Zf7ZQfH2n6sJgJ9AQ"
		brandComplexSlug: "abdurs-brand-complex-for-poc"
	) {
		PieceOfContent {
			_id
			slug
			schemaType
			progress {
				total
				completed
				value
			}
			parentSlug
			parentGenre
			parentId
			type
		}
	}
}
`
const GET_BRAND_HERO = gql `
query ($slug: String!) {
  brandComplex(slug: $slug) {
    BrandComplex {
      _id
      name
      slogan
      slug
      engagement
      primaryColourHexCode
      secondaryColourHexCode
      background {
        svg
        x
        xxx
        __typename
      }
      logo {
        svg
        __typename
      }
      experiences {
        editorsPick {
          _id
          slug
          title
          contents {
            _id
            slug
            type
            parentSlug
            parentColorHexCode
            parentName
            expertNames
            parentId
            parentLogo
            parentGenre
			marketingUrl
            parentSchemaType
            schemaType
            isReadContent
            startDate
            endDate
			brandName
            timezone
            title
            subtitle
            teaserImage
            categoryIds
			categorySlug
            categories {
              _id
              name
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      categoryIds
      categories {
        _id
        name
        __typename
      }
	magazines {
      _id
      slug
      name
      order
    }
      __typename
    }
    __typename
  }
}
`

const GET_BRAND_INSTANCES = gql `
query ($slug:String!){ 
	brandComplexCurrentInstances(slug: $slug) {
	  Instances {
	  _id
	  slug
	  name
	  image
	  startDate
	  endDate
	  timezone
	  supportedApps
	  brandId
	  schemaType
	  colourHexCode
	  type
	  designation
	  genre
	  location
	  publishedAt
	  __typename
	  }
	}
  }
`

const GET_BRAND_POC_ISSUE = gql `
query ($type: PieceOfContentQueryType!, $brandComplexSlug: String!, $PAGE: Int!, $PAGE_SIZE: Int!) {
  pieceOfContent(type: $type, brandComplexSlug: $brandComplexSlug, PAGE: $PAGE, PAGE_SIZE: $PAGE_SIZE) {
    Meta {
      count
      __typename
    }
    PieceOfContent {
      _id
      slug
	  availableUntilDate
	  categorySlug
      schemaType
      brandName
      designation
      type
      parentSlug
      parentSchemaType
      parentGenre
      parentId
      parentColorHexCode
      parentName
	  isReadContent
      language
      startDate
      endDate
      timezone
      duration
      parentGenre
	  marketingUrl
      parentLogo
	  categories {
		_id
		name
	}
		expertIds
		experts {
		_id
		name
		slug
		image
		}
      title
      subtitle
      teaserImage
      language
      expertNames
      expertSlugs
      duration
      expertIds
      __typename
    }
    __typename
  }
}
`


const GET_ALL_BRAND = gql `
query ($type: PieceOfContentQueryType!, $brandComplexSlug: String!, $PAGE: Int!, $PAGE_SIZE: Int!) {
  pieceOfContent(type: $type, brandComplexSlug: $brandComplexSlug, PAGE: $PAGE, PAGE_SIZE: $PAGE_SIZE) {
    Meta {
      count
      __typename
    }
    PieceOfContent {
      _id
      slug
      schemaType
      brandName
      designation
      type
      parentSlug
      parentSchemaType
      parentGenre
      parentId
      parentColorHexCode
      parentName
      language
      startDate
      endDate
      timezone
      duration
      parentGenre
      parentLogo
      title
	  marketingUrl
      subtitle
      teaserImage
      language
      expertNames
      expertSlugs
      duration
      expertIds
      __typename
    }
    __typename
  }
}
`

const GET_POC_DATA_FOR_CATEGORY = gql `
query ( $brandComplexId: String!, $brandComplexSlug: String!, $PAGE: Int!, $PAGE_SIZE: Int!,$categoryIds:[String]) {
	pieceOfContent(type:CATEGORY , brandComplexId: $brandComplexId, brandComplexSlug: $brandComplexSlug, PAGE: $PAGE, PAGE_SIZE: $PAGE_SIZE, categoryIds: $categoryIds) {
	  Meta {
		count
		__typename
	  }
	  PieceOfContent {
		_id
		slug
		schemaType
		brandName
		designation
		type
		parentSlug
		parentSchemaType
		parentGenre
		parentId
		isReadContent
		parentColorHexCode
		parentName
		language
		startDate
		endDate
		timezone
		duration
		marketingUrl
		categories {
			_id
			name
		}
			categorySlug
			expertIds
			experts {
			_id
			name
			slug
			image
			}
		parentGenre
		parentLogo
		title
		subtitle
		teaserImage
		language
		expertNames
		duration
		__typename
	  }
	  __typename
	}
  }
  `

const GET_PARTNER_TYPES = gql`
	query PlatformPartnerTypes {
		platformPartnerTypes(SORT: {order: 1}) {
			PlatformPartnerTypes {
			_id
			displayName
			displayNameDe
			displayNameEn
			displayNameInPartner
			order
			partners{
				_id
			}
		}
	}
}
`
/* not used for now */
const GET_PARTNERS = gql`
	query PlatformPartnerTypes($id: String!) {
		platformPartnerTypes(_id: $id) {
			PlatformPartnerTypes {
				partners {
					_id
					name
					slug
					logo{
						x,
						xx,
						xxx,
						xxxx
					}
				}
			}
		}
	}
`


const GET_PARTNER_DETAILS = gql`
query PlatformPartner($slug: String) {
	platformPartner(slug: $slug) {
		PlatformPartner {
			_id
			name
			publishedAt
			slug
			typeId
			email
			logo {
				x
				xx
				xxx
				xxxx
				svg
			}
			information
			yearFounded
			employeeCount
			headquartersCity
			deepLink
			gallery {
				type
				caption
				videoType
				videoUrl
				image {
					x
					xx
					xxx
					svg
				}
			}
			references {
				title
				subtitle
				subtitle
				url
				type
				resource {
					name
					type
					url
					#uploadedAt
				}
			}
			links {
				urls
				type {
					name
					_id
					icon {
						svg
						x
						xx
						xxx
						xxxx
					}
				}
				typeId
				urls
			}
			timezone
			localizedStartDate
			localizedEndDate
			expertIds
			contactMemberIds
			brandComplexIds
			order
			publishedAt
			updatedAt

			type {
				displayNameDe
				displayNameEn
				displayNameInPartnerDe
				displayNameInPartnerEn
				displayNameInPartner
			}
		}
	}
}

`
const GET_PARTNER_STAFF = gql`
query PlatformPartnerStaffMembers($id: String) {
  platformPartnerStaffMembers(partnerId: $id) {
    PlatformPartnerStaffMembers {
      firstName
      lastName
      position
	  contactEmail
      avatar {
        x
        xx
        xxx
        xxxx
      }
    }
  }
}
`
const GET_PARTNER_EXPERTS = gql`
query AuthorsQuery($page: Int!, $pagesize: Int!, $ids: [String]!) {
	authors(
		PAGE: $page
		PAGE_SIZE: $pagesize
		SORTS: { surname: 1 }
		_id_in: $ids
	) {
		Meta {
			count
		}
		Authors {
			_id
			name
			slug
			surname
			email
			position
			forename
			avatarSquareSmall {
				x
				xx
				xxx
				svg
			}
			avatarSquareLarge {
				x
				xx
				xxx
				svg
			}
			numberOfArticles
		}
	}
}
`

const GET_EXPERT_IDS = gql`
	query PlatformPartner($slug: String) {
		platformPartner(slug: $slug) {
			PlatformPartner {
				expertIds
				}
		}
	}
`
const GET_STAFF_IDS = gql`
	query PlatformPartner($slug: String) {
		platformPartner(slug: $slug) {
			PlatformPartner {
				_id
				}
		}
	}
`
const GET_PARTNERS_BY_PARTENTERTYPEID = gql`
	query PlatformPartner($partnerTypeId: String) {
		platformPartners(typeId: $partnerTypeId  SORTS:[{order: 1},{slug: 1}]) {
			Meta {
				count
			}
			PlatformPartners {
				_id
				slug
				name
				order
				logo {
					x
					xx
					xxx
					xxxx
				}
			}
		}
	}
`
const GET_POCS_FOR_PARTNER_BY_PARTNTERID = gql`
	query ($platformPartnerId: String, $page: Int!, $pageSize: Int!) {
		retrieval(
			platformPartnerId: $platformPartnerId
			PAGE: $page
			PAGE_SIZE: $pageSize
		) {
			results {
				_id
				slug
				availableUntilDate
				categorySlug
				schemaType
				brandName
				designation
				type
				parentSlug
				parentSchemaType
				parentGenre
				parentId
				parentColorHexCode
				parentName
				isReadContent
				language
				startDate
				endDate
				timezone
				duration
				parentGenre
				marketingUrl
				parentLogo
				categories {
					_id
					name
				}

				experts {
					_id
					name
					slug
					image
				}
				title
				subtitle
				teaserImage
				language
				duration
				__typename
			}
		}
	}
`
const GET_BRAND_PARTNERS = gql`
	query PlatformPartner($brandComplexId: String, $page: Int, $pageSize: Int) {
		platformPartners(brandComplexId: $brandComplexId
			PAGE: $page
			PAGE_SIZE: $pageSize
			SORTS: [
			  {order: 1},
			  {slug: 1}
			]
		) {
			Meta {
			  count
			}
			PlatformPartners {
				_id
				slug
				name
				logo {
					x
					xx
					xxx
					xxxx
				}
				order
			}
		}
	}
`
const GET_BRAND_EXPERTS = gql`
	query ($brandComplexId: String, $page: Int, $pageSize: Int) {
		getAuthorsByBrandComplex(brandComplexId: $brandComplexId, PAGE: $page, PAGE_SIZE: $pageSize) {
			Meta {
			count
			}
			Authors {
			_id
			slug
			forename
			surname
			name
			avatarSquareLarge {
				xx
				xxx
			}
			}
			__typename
		}
	}
`;

const GET_BRAND_ISSUES_BY_MAGAZINE_ID = gql `
	query ($brandId: String, $page: Int, $pageSize: Int) {
		issues(brandId: $brandId, PAGE: $page, PAGE_SIZE: $pageSize,
		SORT: {publicationDate: -1} 
		) {
			Meta {
			count
			__typename
			}
			Issues {
			_id
			slug
			cover {
			xxx
				svg
				__typename
			}
			brand {
				name
				slug
				_id
				__typename
			}
			designation
			isIssueCompleted
			__typename
			}
			__typename
		}
	}
`;

const MAGAZINE_EBOOKS_BX = gql`
	query{ brands(
	origin_in: [KIOSK],
	SORT: {order: 1}
	) {
	Meta {
		count
	}
	Brands {
		_id
		name
		slug
		latestIssue {
		_id
		designation
		cover {
			x
			xx
			xxx
			xxxx
			svg
		}
		isIssueCompleted
		}
	}
	}
	}
`;

const AUTHORS_QUERY = gql`
	query ( $page:Int! , $pagesize:Int!){
		authors (
		PAGE: $page
		PAGE_SIZE: $pagesize
		SORTS: {
		surname: 1
		}) {
		Meta {
		count
		}
		Authors {
		_id
		name
		slug      
		surname forename
		avatarSquareSmall {x xx xxx svg}
		avatarSquareLarge{x xx xxx svg}
		numberOfArticles
			}
		}
	}
`;

const AUTHORS_QUERY_WITH_STARTS_WITH = gql`
	query ($startsWith:String!,  $page:Int! , $pagesize:Int!){
	authors (
		PAGE: $page
		PAGE_SIZE: $pagesize
		surname_startsWith: $startsWith
		SORTS: {
		surname: 1
		}) {
		Meta {
		count
		}
		Authors {
		_id
		name
		title
		salutation
		position
		slug
		surname
		forename
		avatarSquareSmall {x xx xxx svg}
		avatarSquareLarge{x xx xxx svg}
		numberOfArticles
			}
	}
	}
`;

const ALL_BRAND_COMPLEXES = gql`
		query AllBrandComplexes {
		brandComplexes(SORT: {order: 1}) {
			Meta {
			count
			__typename
			}
			BrandComplexes {
			_id
			name
			slogan
			slug
			engagement
			primaryColourHexCode
			secondaryColourHexCode
			background {
				svg
				x
				xxx
				__typename
			}
			logo {
				svg
				__typename
			}
			experiences {
				editorsPick {
				_id
				slug
				title
				contents {
					_id
					slug
					type
					parentSlug
					parentColorHexCode
					parentName
					expertNames
					parentId
					parentLogo
					parentGenre
					marketingUrl
					parentSchemaType
					schemaType
					isReadContent
					startDate
					endDate
					brandName
					timezone
					title
					subtitle
					teaserImage
					categoryIds
					categorySlug
					categories {
					_id
					name
					__typename
					}
					__typename
				}
				__typename
				}
				__typename
			}
			categoryIds
			categories {
				_id
				name
				__typename
			}
			magazines {
				_id
				slug
				name
				order
			}
			__typename
			}
			__typename
		}
	}
	`
export default {
    SPEAKER_QUERY:SPEAKER_QUERY,
	SESSIONS_QUERY:SESSIONS_QUERY,
	SESSIONS_TRACKS_QUERY:SESSIONS_TRACKS_QUERY,
	SESSION_BY_SLUG_QUERY:SESSION_BY_SLUG_QUERY,
	SESSION_BY_TRACK_QUERY:SESSION_BY_TRACK_QUERY,
	EXPERT_BY_SLUG_QUERY:EXPERT_BY_SLUG_QUERY,
	TRACK_EXPERT_QUERY:TRACK_EXPERT_QUERY,
	TRACK_BY_SLUG:TRACK_BY_SLUG,
	CAT_SPECIFIC_COURSES:CAT_SPECIFIC_COURSES,
	CAT_SPECIFIC_CONFERENCES:CAT_SPECIFIC_CONFERENCES,
	CAT_SPECIFIC_EXPERTS:CAT_SPECIFIC_EXPERTS,
	CAT_SPECIFIC_INTERVIEWS:CAT_SPECIFIC_INTERVIEWS,
	CAT_SPECIFIC_MAGAZINE:CAT_SPECIFIC_MAGAZINE,
	CAT_SPECIFIC_SERIES:CAT_SPECIFIC_SERIES,
	CAT_SPECIFIC_ARTICLE:CAT_SPECIFIC_ARTICLE,
	CAT_SPECIFIC_HIGHLIGHT:CAT_SPECIFIC_HIGHLIGHT,
	CAT_SPECIFIC_COLUMN:CAT_SPECIFIC_COLUMN,
	CAT_SPECIFIC_ADD_EVENT:CAT_SPECIFIC_ADD_EVENT,
	CAT_SPECIFIC_COLUMN1:CAT_SPECIFIC_COLUMN1,
	GET_BRAND_COMPLEXES:GET_BRAND_COMPLEXES,
	GET_BRAND:GET_BRAND,
	GET_BRAND_HERO:GET_BRAND_HERO,
	GET_BRAND_INSTANCES:GET_BRAND_INSTANCES,
	GET_BRAND_POC_ISSUE:GET_BRAND_POC_ISSUE,
	GET_ALL_BRAND:GET_ALL_BRAND,
	GET_POC_DATA_FOR_CATEGORY:GET_POC_DATA_FOR_CATEGORY,
	GET_PARTNER_TYPES:GET_PARTNER_TYPES,
	GET_PARTNERS:GET_PARTNERS,
	GET_PARTNER_DETAILS:GET_PARTNER_DETAILS,
	GET_PARTNER_STAFF:GET_PARTNER_STAFF,
	GET_PARTNER_EXPERTS:GET_PARTNER_EXPERTS,
	GET_EXPERT_IDS:GET_EXPERT_IDS,
	GET_STAFF_IDS:GET_STAFF_IDS,
	GET_PARTNERS_BY_PARTENTERTYPEID:GET_PARTNERS_BY_PARTENTERTYPEID,
	GET_POCS_FOR_PARTNER_BY_PARTNTERID:GET_POCS_FOR_PARTNER_BY_PARTNTERID,
	GET_BRAND_PARTNERS:GET_BRAND_PARTNERS,
	GET_BRAND_EXPERTS:GET_BRAND_EXPERTS,
	GET_BRAND_ISSUES_BY_MAGAZINE_ID:GET_BRAND_ISSUES_BY_MAGAZINE_ID,
	MAGAZINE_EBOOKS_BX:MAGAZINE_EBOOKS_BX,
	AUTHORS_QUERY:AUTHORS_QUERY,
	AUTHORS_QUERY_WITH_STARTS_WITH:AUTHORS_QUERY_WITH_STARTS_WITH,
	ALL_BRAND_COMPLEXES: ALL_BRAND_COMPLEXES
}




